/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TreatmentCard from './TreatmentCard/index'
import TreatmentPlans from './TreatmentPlans/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'TreatmentCard'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'TreatmentCard'}>
<TreatmentCard
  viewPath={`${viewPath}/TreatmentCard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentPlans'}>
<TreatmentPlans
  viewPath={`${viewPath}/TreatmentPlans`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}